<template>
	<b-modal
		id="assessmentmark"
		centered
		hide-footer
		hide-header
		no-close-on-backdrop
		v-if="showModal"
		v-model="showModal"
		@hidden="showModal = false"
	>
		<div class="d-flex w-100">
			<div class="candash-modal-left width-6"></div>
			<div class="width-94">
				<div class="candash-modal-top px-3 py-2">
					<div class="width-97 ml-1">
						<div class="candash-modal-head">Assessment Mark</div>
						<div class="candash-desc mt-1">
							View your assessment round details
						</div>
					</div>
					<div class="d-flex justify-content-end pointer">
						<img
							class="rotate-on-hover"
							src="../../assets/newdesign/dashboard/blueCross.svg"
							alt=""
							@click="$emit('closeModal')"
						/>
					</div>
				</div>
				<div class="candash-modal-body-14 d-flex mt-1">
					<div class="asp-modal-left-overflow">
						<template v-if="selectedAssessment.companyName">
							<div class="asp-small-grey-txt-2">Company</div>
							<div class="asp-small-grey-txt-3 mt-1 text-break">
								{{ selectedAssessment.companyName }}
							</div>
							<div class="asp-small-grey-txt-2 mt-2">Job Title</div>
							<div class="asp-small-grey-txt-3 mt-1 text-break">
								{{ selectedAssessment.jobName || "NA" }}
							</div>
						</template>
						<template v-else>
							<div class="asp-small-grey-txt-2">Organiser</div>
							<div class="asp-small-grey-txt-3 mt-1 text-break">
								<span>
									{{ selectedAssessment.organiser }}
								</span>
							</div>
						</template>
						<div class="border-bottom mt-3 mb-3"></div>
						<div class="asp-small-grey-txt-2">Topic name</div>
						<div class="asp-small-grey-txt-3 mt-1 text-break">
							<span>
								{{ selectedAssessment.topicName }}
							</span>
						</div>
						<div class="asp-small-grey-txt-2 mt-2">Test name</div>
						<div class="asp-small-grey-txt-3 mt-1 text-break">
							<span>
								{{ selectedAssessment.testName }}
							</span>
						</div>
						<div class="d-flex mt-2">
							<div class="w-50">
								<div class="asp-small-grey-txt-2 d-flex align-items-center">
									<img
										class="mr-1"
										src="../../assets/newdesign/assessPro/blueCalen.svg"
										alt=""
									/>
									Start date :
								</div>
								<div
									class="asp-small-grey-txt-3 mt-1"
									v-if="
										selectedAssessment &&
										selectedAssessment.config &&
										selectedAssessment.config.openTestdt
									"
								>
									{{ formatTime(selectedAssessment.config.openTestdt) }},
									{{ formatDate(selectedAssessment.config.openTestdt) }}
								</div>
							</div>
							<div class="w-50">
								<div class="asp-small-grey-txt-2 d-flex align-items-center">
									<img
										class="mr-1"
										src="../../assets/newdesign/assessPro/blueCalen.svg"
										alt=""
									/>
									End date :
								</div>
								<div
									class="asp-small-grey-txt-3 mt-1"
									v-if="
										selectedAssessment &&
										selectedAssessment.config &&
										selectedAssessment.config.closeTestdt
									"
								>
									{{ formatTime(selectedAssessment.config.closeTestdt) }},
									{{ formatDate(selectedAssessment.config.closeTestdt) }}
								</div>
							</div>
						</div>
						<div class="d-flex mt-2">
							<div class="w-50">
								<div class="asp-small-grey-txt-2">Total attempts</div>
								<div class="asp-small-grey-txt-3 mt-1">
									{{ selectedAssessment.maxnoattempts }}
								</div>
							</div>

							<div
								class="w-50"
								v-if="
									selectedAssessment &&
									selectedAssessment.config &&
									selectedAssessment.config.timebnvalue
								"
							>
								<div class="asp-small-grey-txt-2">Time between attempts</div>
								<div class="asp-small-grey-txt-3 mt-1">
									{{ selectedAssessment.config.timebnvalue }}
									{{ selectedAssessment.config.timebnsel }}
								</div>
							</div>
						</div>
						<div
							class="d-flex mt-2"
							v-if="
								selectedAssessment.group &&
								selectedAssessment.group.candidateType !== 'I'
							"
						>
							<div>
								<div class="asp-small-grey-txt-2">Group Name</div>
								<div class="asp-small-grey-txt-3 mt-1">
									<img
										src="../../assets/newdesign/assessPro/group.svg"
										alt=""
									/>
									{{ selectedAssessment.group.groupName }}
								</div>
							</div>
						</div>
						<div class="d-flex mt-2" v-if="selectedAssessment.shareLink">
							<div>
								<div class="asp-small-grey-txt-2">Test Link</div>
								<div class="d-flex justify-content-between align-items-center">
									<div class="mr-2 mb-mail-txt text-truncate w-92">
										<a
											class="mb-mail-txt"
											target="_blank"
											:href="selectedAssessment.shareLinkWithQuery"
											>{{ shortenLink(selectedAssessment.shareLink) }}</a
										>
									</div>
									<div
										class="pointer"
										@click="
											(isCopied = true),
												copyToClipboard(selectedAssessment.shareLink)
										"
										v-b-tooltip.hover="isCopied ? 'Copied!' : 'Copy'"
									>
										<img
											src="../../assets/newdesign/assessPro/copy.svg"
											alt=""
										/>
									</div>
								</div>
							</div>
						</div>
						<div
							class="border-bottom mt-3 mb-3"
							v-if="
								selectedAssessment.assessmentResponse &&
								selectedAssessment.assessmentResponse[0]?.evaluation
							"
						></div>
						<ProgressBar
							v-if="
								selectedAssessment.assessmentResponse &&
								selectedAssessment.assessmentResponse[0]?.evaluation
							"
							:assessment="selectedAssessment"
						/>
					</div>
					<div class="asp-modal-right-overflow">
						<div
							v-if="remainingAttemptsCount > 0"
							class="total-attemptsremain-box d-flex align-items-center justify-content-center mb-3"
						>
							<span class="fs-14 fw-LM fam-lato text-darkgrey mr-2">
								Total Attempts Remaining:
							</span>
							<span class="fs-16 fw-800 text-blue fam-lato">
								{{ remainingAttemptsCount }}
							</span>
							<span class="fs-16 fw-LM text-darkgrey fam-lato ml-1">
								/&nbsp;{{ selectedAssessment.config.maxnoattempts }}
							</span>
						</div>

						<!-- ================= RECENT ATTEMPT ================= -->
						<div
							v-if="attemptedAttempts.length"
							:class="
								expandedAttempt === attemptedAttempts[0].attemptNo
									? 'asp-new-openbox asp-open-box'
									: 'asp-closed-box'
							"
							class="mb-2"
						>
							<div
								@click="toggleAttempt(attemptedAttempts[0].attemptNo)"
								class="d-flex align-items-center justify-content-between position-relative asp-newpadding asp-top-open-box"
								:class="{
									pointer: attemptedAttempts[0].evaluation,

									'align-items-baseline': !attemptedAttempts[0].evaluation,
								}"
							>
								<div>
									<div class="d-flex align-items-center">
										<div class="asp-black-txt">
											Attempt {{ attemptedAttempts[0].attemptNo }}
										</div>
										<div
											class="recent-attempt-tag text-white fam-lato fs-11 fw-B text-italic ml-1"
										>
											Recent Attempts
										</div>
									</div>
									<div
										v-if="!attemptedAttempts[0].evaluation"
										class="d-flex align-items-center justify-content-between w-100"
									>
										<div class="asp-grey-txt-3 mt-2">Test Taken on :</div>
									</div>
								</div>

								<div class="d-flex align-items-center">
									<div v-if="!attemptedAttempts[0].evaluation">
										<div class="asp-grey-txt-3 fw-M fam-mont color-595959">
											Not Yet Evaluated
										</div>
										<div class="mb-mobile-txt mt-2 text-end">
											{{ formatDate(attemptedAttempts[0].createdAt) }}
										</div>
									</div>
									<span
										class="asp-greentxt mr-4"
										v-else-if="attemptedAttempts[0].resultPerAttemptStatusCode"
									>
										PASSED
									</span>
									<span class="asp-redtxt mr-4" v-else> FAILED </span>

									<img
										v-if="attemptedAttempts[0].evaluation"
										src="../../assets/newdesign/assessPro/bluedownarrow.svg"
										alt=""
									/>
								</div>
							</div>

							<b-collapse
								:visible="expandedAttempt === attemptedAttempts[0].attemptNo"
								v-if="attemptedAttempts[0].evaluation"
							>
								<div
									class="d-flex justify-content-between align-items-center px-2 new-border-bottom-blue"
								>
									<div class="asp-grey-txt-3">Test Taken on :</div>
									<div class="mb-mobile-txt">
										{{ formatDate(attemptedAttempts[0].createdAt) }}
									</div>
								</div>

								<div v-if="attemptedAttempts[0].evaluation">
									<div class="asp-blue-bottom py-2 pl-2 pr-0">
										<div
											class="asp-blue-txt-2 d-flex align-items-center justify-content-between"
										>
											<div class="d-flex align-items-center">
												Total Marks :&nbsp;
												{{ attemptedAttempts[0].totalMarksScoredPerAttempt }}/
												{{
													roundToTwo(attemptedAttempts[0].totalMarksPerAttempt)
												}}
											</div>
											<div class="d-flex align-items-center mr-2">
												Passing Percentage (%) :&nbsp;
												{{ attemptedAttempts[0].passingPercentage }}/100
											</div>
										</div>

										<div
											class="d-flex align-items-center justify-content-between asp-small-grey-txt mt-2"
											v-if="attemptedAttempts[0].testResponse.length"
										>
											<div>Sections</div>
											<div class="mr-2">Marks</div>
										</div>

										<div class="asp-right-modal-overflow pr-1 mr-1">
											<div
												v-for="(section, index) in attemptedAttempts[0]
													.testResponse"
												:key="index"
												class="d-flex align-items-center justify-content-between mt-2"
											>
												<div class="mb-mobile-txt-2 text-truncate w-75">
													{{ section.sectionName }}
												</div>
												<div class="asp-blue-txt-3">
													{{ roundToTwo(section.sectionMarks) }}/{{
														roundToTwo(section.serctionTotalMarks)
													}}
												</div>
											</div>
										</div>
									</div>

									<div
										class="detailed-report-box fw-M fs-13 fam-mont text-white d-flex justify-content-center align-items-center pointer"
										@click="gotoasmntReport(attemptedAttempts[0])"
									>
										View Detailed Report
										<img
											class="ml-2"
											src="../../assets/img/whiteforwardarw.svg"
											alt=""
										/>
									</div>
								</div>

								<div class="asp-blue-bottom py-2 pl-2 pr-0" v-else>
									Yet to evaluate
								</div>
							</b-collapse>
						</div>

						<!-- ================= DIVIDER ================= -->
						<div
							v-if="attemptedAttempts.length > 1"
							class="position-relative py-2"
						>
							<hr style="border-top: 2px solid #8c8c8c" />
							<div class="prevatempt-txt fam-lato fw-M fs-14 color-595959 mx-3">
								Previous Attempts
							</div>
						</div>

						<!-- ================= PREVIOUS ATTEMPTS ================= -->
						<div
							v-for="attempt in attemptedAttempts.slice(1)"
							:key="attempt.attemptNo"
							:class="
								expandedAttempt === attempt.attemptNo
									? 'asp-new-openbox asp-open-box'
									: 'asp-closed-box'
							"
							class="mb-2"
						>
							<div
								@click="attempt.evaluation && toggleAttempt(attempt.attemptNo)"
								class="d-flex align-items-center justify-content-between position-relative asp-newpadding asp-top-open-box"
								:class="{ pointer: attempt.evaluation }"
							>
								<div class="asp-black-txt">Attempt {{ attempt.attemptNo }}</div>

								<div class="d-flex align-items-center">
									<span class="asp-grey-txt-3" v-if="!attempt.evaluation">
										Not Yet Evaluated
									</span>
									<span
										class="asp-greentxt mr-4"
										v-else-if="attempt.resultPerAttemptStatusCode"
									>
										PASSED
									</span>
									<span class="asp-redtxt mr-4" v-else> FAILED </span>

									<img
										v-if="attempt.evaluation"
										src="../../assets/newdesign/assessPro/bluedownarrow.svg"
										alt=""
									/>
								</div>
							</div>

							<b-collapse
								:visible="expandedAttempt === attempt.attemptNo"
								v-if="attempt.evaluation"
							>
								<div
									class="d-flex justify-content-between align-items-center px-2 new-border-bottom-blue"
								>
									<div class="asp-grey-txt-3">Test Taken on :</div>
									<div class="mb-mobile-txt">
										{{ formatDate(attempt.createdAt) }}
									</div>
								</div>

								<div v-if="attempt.evaluation">
									<div class="asp-blue-bottom py-2 pl-2 pr-0">
										<div
											class="asp-blue-txt-2 d-flex align-items-center justify-content-between"
										>
											<div class="d-flex align-items-center">
												Total Marks :&nbsp;
												{{ attempt.totalMarksScoredPerAttempt }}/{{
													roundToTwo(attempt.totalMarksPerAttempt)
												}}
											</div>
											<div class="d-flex align-items-center mr-2">
												Passing Percentage (%) :&nbsp;
												{{ attempt.passingPercentage }}/100
											</div>
										</div>

										<div
											class="d-flex align-items-center justify-content-between asp-small-grey-txt mt-2"
											v-if="attempt.testResponse.length"
										>
											<div>Sections</div>
											<div class="mr-2">Marks</div>
										</div>

										<div class="asp-right-modal-overflow pr-1 mr-1">
											<div
												v-for="(section, index) in attempt.testResponse"
												:key="index"
												class="d-flex align-items-center justify-content-between mt-2"
											>
												<div class="mb-mobile-txt-2 text-truncate w-75">
													{{ section.sectionName }}
												</div>
												<div class="asp-blue-txt-3">
													{{ roundToTwo(section.sectionMarks) }}/{{
														roundToTwo(section.serctionTotalMarks)
													}}
												</div>
											</div>
										</div>
									</div>

									<div
										class="detailed-report-box fw-M fs-13 fam-mont text-white d-flex justify-content-center align-items-center pointer"
										@click="gotoasmntReport(attempt)"
									>
										View Detailed Report
										<img
											class="ml-2"
											src="../../assets/img/whiteforwardarw.svg"
											alt=""
										/>
									</div>
								</div>

								<div class="asp-blue-bottom py-2 pl-2 pr-0" v-else>
									Yet to evaluate
								</div>
							</b-collapse>
						</div>
					</div>
				</div>
				<div
					class="candash-modal-footer d-flex align-items-center justify-content-end"
				>
					<b-button class="candash-cancelBtn mr-4" @click="$emit('closeModal')"
						>Cancel</b-button
					>
					<b-button
						v-if="selectedAssessment.attemptsLeft == 0"
						class="candash-addBtn"
						@click="$emit('closeModal')"
						>Okay</b-button
					>
					<b-button
						v-else
						class="candash-addBtn"
						@click="$emit('take-next-attempt')"
						>Retake Test</b-button
					>
				</div>
			</div>
		</div>
	</b-modal>
</template>

<script>
import ProgressBar from "@/components/ProgressBar.vue";
export default {
	name: "AssessmentMarksModal",
	props: {
		showMarks: Boolean,
		selectedAssessment: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			showModal: this.showMarks,
			expandedAttempt: null,
			isCopied: false,
		};
	},
	components: {
		ProgressBar,
	},
	watch: {
		showMarks(val) {
			this.showModal = val;
		},
		"selectedAssessment.assessmentResponse": {
			immediate: true,
			deep: true,
			handler(val) {
				if (val && val.length && !this.expandedAttempt) {
					// latest attempt = highest attemptNo
					const latest = [...val].sort((a, b) => b.attemptNo - a.attemptNo)[0];

					this.expandedAttempt = latest.attemptNo;
				}
			},
		},
	},
	computed: {
		attemptedAttempts() {
			return this.selectedAssessment.assessmentResponse
				.filter((a) => a.attemptNo) // attempted ones
				.sort((a, b) => b.attemptNo - a.attemptNo); // latest first
		},

		remainingAttemptsCount() {
			return (
				this.selectedAssessment.config.maxnoattempts -
				this.selectedAssessment.assessmentResponse.length
			);
		},
	},
	methods: {
		gotoasmntReport(section) {
			console.log("hiiiiiiii", section);

			this.$router.push({
				name: "AssessmentReport",
				query: {
					testID: this.selectedAssessment.testID,
					groupID: this.selectedAssessment.group.groupID,
					attemptNo: section.attemptNo,
				},
			});
		},
		shortenLink(link) {
			return "https://.../" + link.split("/").slice(-1);
		},
		copyToClipboard(text) {
			this.$copyToClipboard(text);
		},
		formatTime(date) {
			return new Date(date)
				.toLocaleString("en-IN", {
					hour: "numeric",
					minute: "numeric",
					hour12: true,
				})
				.toUpperCase();
		},
		formatDate(date) {
			return new Date(date)
				.toLocaleString("en-IN", {
					day: "2-digit",
					month: "2-digit",
					year: "numeric",
				})
				.replaceAll("/", "-");
		},
		toggleAttempt(no) {
			this.expandedAttempt = this.expandedAttempt === no ? null : no;
		},
		roundToTwo(num) {
			return Math.round(num);
		},
	},
};
</script>

<style>
.total-attemptsremain-box {
	padding: 10px 12px;
	background: #fff6d7;
	border-radius: 8px;
}
.asp-new-openbox {
	background: linear-gradient(#f6f9fb, #f6f9fb) padding-box,
		linear-gradient(0deg, #20639b 0%, rgba(32, 99, 155, 0.2) 120.58%) border-box;

	border: 1px solid transparent;
	border-radius: 12px;
	overflow: hidden;
}
.new-border-bottom-blue {
	border-bottom: 1px solid var(--bg-proTheme);
	border-radius: 0px;
	background-color: #ffffff;
	border-bottom: 1px solid #20639b;
}
.recent-attempt-tag {
	padding: 0px 8px;
	background: linear-gradient(90deg, rgba(255, 163, 79, 0.49) 0%, #ffa34f 100%);
	border-radius: 4px;
}
.asp-newpadding {
	padding: 6px 8px;
}
.detailed-report-box {
	padding: 10px 20px;
	background: linear-gradient(0deg, #20639b, #20639b), #ffffff;
	border-radius: 0px 0px 8px 8px;
}
.prevatempt-txt {
	position: absolute;
	left: 25%;
	top: 13px;
	background: #fff;
	padding: 0 12px;
}
</style>
